import React, { useEffect, useState } from "react";
import axios from "../utils/axiosConfig";

const ShipperDetailModal = ({ show, dealId, onClose }) => {

  const [shipper, setShipper] = useState(null);
  const [contacts, setContacts] = useState([]);

  useEffect(() => {

    if (show && dealId) {
      fetchShipper();
    }

  }, [show, dealId]);


  const fetchShipper = async () => {

    try {

      const res = await axios.get(`/shippers/details/${dealId}`);

      setShipper(res.data.shipper);
      setContacts(res.data.contacts || []);

    } catch (err) {

      console.error(err);

    }

  };


  if (!show) return null;


  return (

    <div className="modal show d-block" style={{background:"rgba(0,0,0,0.5)"}}>

      <div className="modal-dialog modal-lg">

        <div className="modal-content">

          <div className="modal-header">
            <h5>Shipper Contact Details</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>


          <div className="modal-body">

            {/* SHIPPER DETAILS */}

            <div className="card mb-3">

              <div className="card-header">
                Shipper Details
              </div>

              <div className="card-body">

                <div className="row">

                  <div className="col-md-6">
                    <b>Name :</b> {shipper?.ShipperName}
                  </div>

                  <div className="col-md-6">
                    <b>Phone :</b> {shipper?.Phone}
                  </div>

                </div>

                <div className="row mt-2">

                  <div className="col-md-6">
                    <b>Mobile :</b> {shipper?.Mobile}
                  </div>

                  <div className="col-md-6">
                    <b>Email :</b> {shipper?.Email}
                  </div>

                </div>

                <div className="row mt-2">

                  <div className="col-md-12">
                    <b>Address :</b> {shipper?.Address}
                  </div>

                </div>

              </div>

            </div>


            {/* CONTACT PERSON GRID */}

            <div className="card">

              <div className="card-header">
                Shipper Contact Details
              </div>

              <div className="card-body">

                {contacts.length === 0 ? (

                  <div className="text-muted">
                    No contact details found
                  </div>

                ) : (

                  <table className="table table-bordered table-sm">

                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Contact No</th>
                        <th>Email</th>
                      </tr>
                    </thead>

                    <tbody>

                      {contacts.map((c, i) => (

                        <tr key={i}>
                          <td>{c.ContactPerson}</td>
                          <td>{c.ContactNo}</td>
                          <td>{c.Email}</td>
                        </tr>

                      ))}

                    </tbody>

                  </table>

                )}

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  );

};

export default ShipperDetailModal;